var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCcPersonIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.9,0c9,0,16.6,3.1,22.7,9.3C60.9,15.5,64,23,64,32s-3,16.5-9.1,22.5c-6.5,6.3-14.2,9.5-23,9.5 c-8.6,0-16.2-3.1-22.5-9.4S0,40.8,0,32S3.1,15.7,9.4,9.3C15.6,3.1,23.1,0,31.9,0z M32.1,5.8c-7.3,0-13.4,2.6-18.5,7.7 C8.4,18.8,5.8,25,5.8,32c0,7.1,2.6,13.2,7.8,18.4s11.4,7.8,18.5,7.8s13.3-2.6,18.6-7.8c5-4.8,7.5-11,7.5-18.3s-2.6-13.5-7.7-18.6 C45.5,8.3,39.3,5.8,32.1,5.8z M40.6,24.1v13.1H37v15.5H27V37.1h-3.7v-13c0-0.6,0.2-1.1,0.6-1.5s0.9-0.6,1.5-0.6h13.1 c0.5,0,1,0.2,1.4,0.6C40.4,23,40.6,23.5,40.6,24.1z M27.5,15.8c0-3,1.5-4.5,4.5-4.5s4.5,1.5,4.5,4.5S35,20.3,32,20.3 S27.5,18.8,27.5,15.8z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCcPersonIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cc_person_icon.0722c9c8.svg";
export { ForwardRef as ReactComponent };